
import moment from "moment";

/** Ponctuation / symboles ASCII (les lettres accentuées ne comptent pas comme « spécial »). */
const PASSWORD_ASCII_SPECIAL_RE = /[\x21-\x2F\x3A-\x40\x5B-\x60\x7B-\x7E]/;

/**
 * @returns {{ minLength: boolean, upper: boolean, lower: boolean, digit: boolean, special: boolean, allValid: boolean }}
 */
export function passwordPolicyState(input) {
    const s = String(input ?? "");
    const minLength = s.length >= 8;
    const upper = /[A-Z]/.test(s);
    const lower = /[a-z]/.test(s);
    const digit = /[0-9]/.test(s);
    const special = PASSWORD_ASCII_SPECIAL_RE.test(s);
    const allValid = minLength && upper && lower && digit && special;
    return { minLength, upper, lower, digit, special, allValid };
}

export const formRules = {
    required(input) {
        if (!input || input == "")
            return "Le champ est requis";
        return true;
    },
    password(input) {
        if (!input || input === "")
            return true;
        const st = passwordPolicyState(input);
        if (st.allValid)
            return true;
        const parts = [];
        if (!st.minLength)
            parts.push("au moins 8 caractères");
        if (!st.upper)
            parts.push("une majuscule");
        if (!st.lower)
            parts.push("une minuscule");
        if (!st.digit)
            parts.push("un chiffre");
        if (!st.special)
            parts.push("un caractère spécial");
        return "Le mot de passe doit contenir : " + parts.join(", ") + ".";
    },
    email(input) {
        if (!input.match(/(?:[a-z0-9+!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/gi)) {
            return "Format d'email invalide";
        }
        return true;
    },
    nom_prenom(input) {
        if (!input.match("^[a-zA-ZÀÂÉÊÈËÌÏÎÔÙÛÇÆŒàâéêèëìïîôùûçæœ -]*$")) {
            return "Ce champ n'accepte pas les charactères spéciaux";
        }
        return true;
    },
    nom_groupe(input) {
        // Define the regular expression pattern for authorized characters
        const authorizedPattern = /^[A-Z0-9+\-=/*#@%!?£€({[\]})|. ]+$/;

        // Check if the input string matches the authorized pattern
        if (authorizedPattern.test(input)) {
            // String contains only authorized characters
            return true;
        } else {
            // Find the first unauthorized character
            const unauthorizedCharacter = input.match(/[^A-Z0-9+\-=/*#@%!?£€({[\]})|. ]/)[0];
            if (unauthorizedCharacter.match(/[a-z]/)) return "Ce champ n'accepte pas les minuscules";
            if (unauthorizedCharacter.match(/[ÀÁÂÃÄÅàáâãäåÈÉÊËèéêëÌÍÎÏìíîïÒÓÔÕÖØòóôõöøÙÚÛÜùúûü]/)) return "Ce champ n'accepte pas les caractères accentués";
            return "Ce champ n'accepte pas ce caractère: " + unauthorizedCharacter;
        }
    },

    licence_ffa(input) {
        if (!input || input == '') return true;
        if (!input.match("^[0-9]{7}$") && !input.match("^[0-9]{6}$")) {
            return "Le format ne correspond pas à un numéro de licence FFA";
        }
        return true;
    },
    licence_ffrp(input) {
        if (!input || input == '') return true;
        if (!input.match("^[0-9]{7}[A-Z]$")) {
            return "Le format ne correspond pas à un numéro de licence FFRP";
        }
        return true;
    },
    licence_ffr(input) {
        if (!input || input == '') return true;
        if (!input.match("^[0-9]{7}[A-Z]$")) {
            return "Le format ne correspond pas à un numéro de licence FFRandonnée";
        }
        return true;
    },
    licence_fftri(input) {
        if (!input || input == '') return true;
        if (!input.match("^[0-9A-Z]{5,10}$")) {
            return "Le format ne correspond pas à un numéro de licence FFTRI compétition";
        }
        return true;
    },
    pps(input) {

        if (!input || input == '') return true;
        if (!input.match("^[0-9A-Z]{11}$")) {
            return "Le format ne correspond pas à un numéro de PPS (11 charactères alphanumériques majuscules)";
        }
        return true;
    },
    club(input) {
        if (!input || input == '') return true;

        // Define the regular expression pattern for authorized characters
        const authorizedPattern = /^[A-Z0-9+\-=/*#@%!?£€({[\]})|. ]+$/;

        // Check if the input string matches the authorized pattern
        if (authorizedPattern.test(input)) {
            // String contains only authorized characters
            return true;
        } else {
            // Find the first unauthorized character
            const unauthorizedCharacter = input.match(/[^A-Z0-9+\-=/*#@%!?£€({[\]})|. ]/)[0];
            if (unauthorizedCharacter.match(/[a-z]/)) return "Le champ Club n'accepte pas les minuscules";
            if (unauthorizedCharacter.match(/[ÀÁÂÃÄÅàáâãäåÈÉÊËèéêëÌÍÎÏìíîïÒÓÔÕÖØòóôõöøÙÚÛÜùúûü]/)) return "Le champ Club n'accepte pas les caractères accentués";
            return "Le champ Club n'accepte pas ce caractère: " + unauthorizedCharacter;
        }
    },
    equipe(input, index_equipe, equipes) {
        if (!input || input == '') return "Vous devez renseigner un nom d'équipe";
        for (let i = 0; i < equipes.length; i++) {
            if (i == index_equipe) continue;
            if (equipes[i].nom == input) return "Ce nom d'équipe est déjà utilisé";
        }
        const authorizedPattern = /^[A-Z0-9+\-=/*#@%!?£€({[\]})|. ]+$/;
        // Check if the input string matches the authorized pattern
        if (authorizedPattern.test(input)) {
            // String contains only authorized characters
            return true;
        } else {
            // Find the first unauthorized character
            const unauthorizedCharacter = input.match(/[^A-Z0-9+\-=/*#@%!?£€({[\]})|. ]/)[0];
            if (unauthorizedCharacter.match(/[a-z]/)) return "Le nom d'équipe n'accepte pas les minuscules";
            if (unauthorizedCharacter.match(/[ÀÁÂÃÄÅàáâãäåÈÉÊËèéêëÌÍÎÏìíîïÒÓÔÕÖØòóôõöøÙÚÛÜùúûü]/)) return "Le nom d'équipe n'accepte pas les caractères accentués";
            return "Le nom d'équipe n'accepte pas ce caractère: " + unauthorizedCharacter;
        }
    },

    fileSize(input) {
        if (input && input.size > 2000000) {
            return "Le fichier est trop volumineux (max 2Mo). Astuce : Faites une capture d'écran de votre document pour obtenir une copie inférieur à 2Mo";
        }
        return true;

    },
    code_reduction(input, codes) {
        if (input && input.length < 4) {
            return "Le code doit contenir au moins 4 charactères";
        }
        if (input && !input.match("^[a-zA-Z0-9]*$")) {
            return "Ce champ n'accepte pas les charactères spéciaux";
        }
        if (codes.list && input && codes.list.find(code => code.nom == input)) {
            return "Ce code est déjà utilisé";
        }
        return true;
    },

    userInput(champ, courses = [], packs = [], mode = "default", is_ffa = false, is_ffrp = false, is_fftri = false) {



        // Si le champ n'est pas obligatoire et vide, il est valide
        if (champ.mandatory == "0" && champ.value == "" || (mode == "admin" && champ.nom != 'mail')) {
            return true;
        }

        if (champ.value === "" && champ.mandatory == "1" && champ.nom == 'date_naissance') {
            return "Ce champ est requis, au format JJ/MM/AAAA";
        }

        // Si le champ est obligatoire et vide, invalide
        if (champ.value === "" && champ.mandatory == "1") {
            return "Ce champ est requis";
        }

        if (champ.nom == 'type_document' && champ.mandatory == "1" && (champ.value == '' || champ.value == 'Sélectionnez le type de document')) {
            return "Ce champ est requis";
        }
        // Si c'est un champ texte ou autocomplete
        if (champ.type == "text" || champ.type == "autocomplete") {

            if (champ.nom == "nom" || champ.nom == "prenom") {
                return this.nom_prenom(champ.value);
            }
            // Si c'est le champ d'email, vérifie le format
            else if (champ.nom == "mail") {
                return this.email(champ.value);
            }
            else if (champ.nom == "club") {
                return this.club(champ.value);
            }
        }
        if (champ.type == "date") {
            if (champ.nom == "date_naissance") {
                return this.check_date_naissance_in_range(champ.value, courses, packs);
            }
            if (champ.nom == 'naissance_enfant_1_ndr24' || champ.nom == 'naissance_enfant_2_ndr24') {
                return this.check_date_naissance_enfant_ndr24(champ.value);
            }
        }
        if (champ.type == "select") {
            if (champ.nom == "sexe") {
                return this.check_limitation_sexe(champ.value, courses, packs);
            }

        }
        if (champ.type == "select_multiple") {
            if (!champ.value) {
                return "Ce champ est requis";
            }
            // Vérifier que le champ est obligatoire et qu'il a au moins une valeur
            if (champ.mandatory == "1" && champ.value.length == 0) {
                return "Ce champ est requis";
            }

            return true;
        }
        if (champ.nom == 'licence' && is_ffrp) {
            return this.licence_ffrp(champ.value);
        }

        if (champ.nom == 'licence' && is_ffa) {
            return this.licence_ffa(champ.value);
        }

        if (champ.nom == 'licence' && is_fftri) {
            return this.licence_fftri(champ.value);
        }

        if (champ.nom == 'numero_pps' && is_ffa) {
            return this.pps(champ.value);
        }
        if (champ.nom == 'numero_licence_ffr') {
            return this.licence_ffr(champ.value);
        }

        if (champ.nom == 'cote_betrail_indicatif') {
            return this.cote_betrail_indicatif(champ.value);
        }



        return true;
    },

    cote_betrail_indicatif(cote) {
        const cote_betrail = parseInt(cote);
        if (isNaN(cote_betrail)) {
            return "Votre indice Betrail n'est pas valide";
        }
        if (cote_betrail < 0 || cote_betrail > 100) {
            return "Votre indice Betrail doit être comprise entre 0 et 100";
        }
        if (cote_betrail < 40) {
            return "Votre indice Betrail doit être supérieur à 40";
        }
        return true;
    },

    check_date_naissance_enfant_ndr24(naissance) {
        let date = moment(naissance);
        let date_limit = moment("2012-09-07", "YYYY-MM-DD");
        if (!date.isValid()) {
            return "La date de naissance n'est pas valide";
        }
        if (date.isBefore(date_limit)) {
            return "Les enfants doivent être nés après le " + date_limit.format("DD/MM/YYYY") + " pour participer à la NDR24";
        }
    },

    check_date_naissance_in_range(naissance, courses, packs) {

        let date = moment(naissance);
        if (!date.isValid()) {
            return "La date de naissance n'est pas valide";
        }
        if (date.isBefore(moment().subtract(100, 'years'))) {
            return "La date de naissance est trop ancienne";
        }
        for (let i = 0; i < courses.list.length; i++) {
            let course = courses.list[i];
            if (!course.selected) { continue; }
            if (course.metadatas.naissance_min) {
                let min_date = moment(course.metadatas.naissance_min);
                if (date.isBefore(min_date)) {
                    return "La course '" + course.nom + "' n'autorise que les participants nés après le " + min_date.format("DD MMMM YYYY");
                }
            }
            if (course.metadatas.naissance_max) {
                let max_date = moment(course.metadatas.naissance_max);
                if (date.isAfter(max_date)) {
                    return "La course '" + course.nom + "' n'autorise que les participants nés avant le " + max_date.format("DD MMMM YYYY");
                }
            }
        }
        for (let i = 0; i < packs.list.length; i++) {
            let pack = packs.list[i];
            if (!pack.selected) { continue; }
            if (pack.metadatas.naissance_min) {
                let min_date = moment(pack.metadatas.naissance_min);
                if (date.isBefore(min_date)) {
                    return "Le pack '" + pack.nom + "' n'autorise que les participants nés après le " + min_date.format("DD MMMM YYYY");
                }
            }
            if (pack.metadatas.naissance_max) {
                let max_date = moment(pack.metadatas.naissance_max);
                if (date.isAfter(max_date)) {
                    return "Le pack '" + pack.nom + "' n'autorise que les participants nés avant le " + max_date.format("DD MMMM YYYY");
                }
            }
        }
        return true;
    },

    check_limitation_sexe(sexe, courses, packs) {
        const sexe_value = sexe;

        for (let i = 0; i < courses.list.length; i++) {
            let course = courses.list[i];
            if (!course.selected) { continue; }
            const vague = course.get_selected_vague?.();
            if (vague?.has_limitation_sexe?.() && !vague.allows_sexe(sexe_value)) {
                return "La vague '" + vague.nom + "' de la course '" + course.nom + "' est limitée aux " + vague.get_limitation_sexe_label();
            }
        }

        if (sexe == "M") sexe = "Homme";
        if (sexe == "F") sexe = "Femme";

        for (let i = 0; i < courses.list.length; i++) {
            let course = courses.list[i];
            if (!course.selected) { continue; }
            if (course.metadatas.limitation_sexe) {

                if (course.metadatas.limitation_sexe != "Mixte" && course.metadatas.limitation_sexe != sexe) {
                    return "La course '" + course.nom + "' est limitée aux " + course.metadatas.limitation_sexe + "s";
                }
            }
        }
        for (let i = 0; i < packs.list.length; i++) {
            let pack = packs.list[i];
            if (!pack.selected) { continue; }
            if (pack.metadatas.limitation_sexe) {
                if (pack.metadatas.limitation_sexe != "Mixte" && pack.metadatas.limitation_sexe != sexe) {
                    return "Le pack '" + pack.nom + "' est limité aux " + pack.metadatas.limitation_sexe + "s";
                }
            }
        }
        return true;
    },



}